import React, { Component } from 'react';
import { connect } from 'react-redux';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableBody from '@material-ui/core/TableBody';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TablePagination from '@material-ui/core/TablePagination';
import Paper from '@material-ui/core/Paper';
import RUReservationAPI from '../../../../../API/UsedRentalsReservationAPI';
import RUReservationsOnHoldTableHeader from './RUReservationsOnHoldTableHeader';
import RUReservationsToolbar from '../../RUReservationsToolbar';
import RUReservationsExtendCancelModal from '../RUReservationsExtendCancelModal';
import CancelIcon from '@material-ui/icons/DeleteForever';
import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import LinearProgress from '../../../../Utils/LinearProgress';
import { FormatDateTime } from '../../../../Utils/GenericFunctions';
import SnackbarAlert from '../../../../Utils/SnackbarAlert';
import { NO_TABLE_DATA_MESSAGE, STARTING_TABLE_PAGE, DEFAULT_ROWS_PER_PAGE, ORDER_ASCENDING, ORDER_BY_RESERVATION_DATE, RESERVATION_TABLE_RELOAD_TIMER, UR_COMMERCIAL_GROUP } from '../../../../../Utils/Constants';
import { handleServerError } from '../../../../../Utils/Helper';


const styles = theme => ({
  root: {
    width: '100%',
    marginTop: theme.spacing.unit,
    backgroundColor: '#F6F6F6'
  },
  tableWrapper: {
    overflowX: 'auto'
  },
  tblHead: {
    backgroundColor: '#A5A5A5'
  },
  tblBorder: {
    border: '2px solid #ffffff',
    fontSize: '12px'
  },
  textCenter: {
    textAlign: 'center'
  },
  tblRow: {
    backgroundColor: '#F2F2F2',
    '&:hover': {
      backgroundColor: theme.palette.primary.light
    },
    '&:nth-of-type(odd)': {
      backgroundColor: '#E1E1E1',
      '&:hover': {
        backgroundColor: theme.palette.primary.light
      },
    },
    height: '30px'
  },
  cellPadding: {
    paddingLeft: '6px'
  },
  lastCellPadding: {
    paddingLeft: '6px',
    '&:last-child': {
      paddingLeft: '6px'
    }
  },
  buttonSizeTbl: {
    width: '30px',
    height: '30px'
  },
  iconsWidth: {
    width: '60px'
  },
  tblFooter: {
    height: '30px',
    minHeight: '30px'
  },
  pageButton: {
    width: '30px',
    height: '30px',
    margin: '0px 8px'
  }
});


export class RUReservationsOnHoldTable extends Component {
  _isMounted = true;
  searchTimer = null;
  dataAPI;

  constructor(props) {
    super(props);
    this.state = {
      order: ORDER_ASCENDING,
      orderBy: ORDER_BY_RESERVATION_DATE,
      data: [],
      page: STARTING_TABLE_PAGE,
      rowsPerPage: DEFAULT_ROWS_PER_PAGE,
      count: 0,
      search: '',
      reloading: false,
      openModal: false,
      openReasons: '',
      openReasonsTitle: '',
      carReservationId: '',
      openError: false,
      alertMessage: ''
    };
    this.dataAPI = new RUReservationAPI();
  }

  componentDidMount() {
    this._isMounted = true;
    this.reloadTable();
    this.interval = setInterval(() => {
      this.reloadTable();
    }, RESERVATION_TABLE_RELOAD_TIMER);
  };

  componentWillUnmount() {
    this._isMounted = false;
    clearInterval(this.interval);
  };

  componentWillReceiveProps() {
    this.reloadTable();
  };

  reloadTable() {
    this.setState({ reloading: true });
    this.dataAPI.getRUAwaitingReservations(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted) {
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          page: STARTING_TABLE_PAGE,
          reloading: false
        });
      }
    }).catch((error) => {
      if (this._isMounted) {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      }
    });
  };

  handleRequestSort = (event, property) => {
    const orderBy = property;
    let order = 'desc';
    if (this.state.orderBy === property && this.state.order === 'desc') {
      order = 'asc';
    }
    this.setState({ reloading: true });
    this.dataAPI.getRUAwaitingReservations(this.state.page, this.state.rowsPerPage, orderBy, order, this.state.search).then((response) => {
      if (this._isMounted) {
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          order, orderBy,
          reloading: false
        });
      }
    }).catch((error) => {
      if (this._isMounted) {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      }
    });
  };

  handleChangePage = (event, page) => {
    this.setState({ reloading: true });
    this.dataAPI.getRUAwaitingReservations(page, this.state.rowsPerPage, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted) {
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          page: page,
          reloading: false
        });
      }
    }).catch((error) => {
      if (this._isMounted) {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      }
    });
  };

  handleChangeRowsPerPage = event => {
    this.setState({ reloading: true });
    this.dataAPI.getRUAwaitingReservations(this.state.page, event.target.value, this.state.orderBy, this.state.order, this.state.search).then((response) => {
      if (this._isMounted) {
        this.setState({
          data: response.data.ListReservedCars,
          count: response.data.NumberFilteredResults,
          rowsPerPage: event.target.value,
          reloading: false
        });
      }
    }).catch((error) => {
      if (this._isMounted) {
        this.setState({
          reloading: false,
          openError: true,
          alertMessage: handleServerError(error)
        })
      }
    });
  };

  reloadTableBySearch(searchBy) {
    this.setState({ reloading: true });
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => {
      this.dataAPI.getRUAwaitingReservations(STARTING_TABLE_PAGE, this.state.rowsPerPage, this.state.orderBy, this.state.order, searchBy).then((response) => {
        if (this._isMounted) {
          this.setState({
            data: response.data.ListReservedCars,
            count: response.data.NumberFilteredResults,
            search: searchBy,
            page: STARTING_TABLE_PAGE,
            reloading: false
          });
        }
      }).catch((error) => {
        if (this._isMounted) {
          this.setState({
            reloading: false,
            openError: true,
            alertMessage: handleServerError(error)
          })
        }
      });
    }, 1500);
  };

  handleCloseSnackbar = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({
      openError: false,
      alertMessage: ''
    });
  };

  detectCancellation = () => {
    this.props.detectCancellation();
  };

  handleClose = () => {
    this.setState({ openModal: false });
  };

  handleClickCancel = (reservationId) => {
    this.setState({
      openModal: true,
      carReservationId: reservationId,
      openReasons: 'Cancellation',
      openReasonsTitle: 'SELECIONAR MOTIVO DE CANCELAMENTO DE RESERVA'
    });
  };

  renderTableRecords(cReservationOnHoldList) {
    const { classes } = this.props;

    const cReservationsOnHold = cReservationOnHoldList.map(rItem => {
      return (
        <TableRow key={rItem.reservationId} tabIndex={-1} className={classes.tblRow} >
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarBrandDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarModelDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarAnnouncedOptionalsDescription}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {rItem.reservedCarColorDesc}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, classes.textCenter)} component='th' scope='row' padding='none'>
            {FormatDateTime(rItem.reservedCarDate)}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, this.props.user.UserRoleType.indexOf(UR_COMMERCIAL_GROUP) < 0 ? classes.lastCellPadding : classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarClient}
          </TableCell>
          <TableCell className={classNames(classes.tblBorder, this.props.user.UserRoleType.indexOf(UR_COMMERCIAL_GROUP) < 0 ? classes.lastCellPadding : classes.cellPadding)} component='th' scope='row' padding='none'>
            {rItem.reservedCarHolderName}
          </TableCell>
          {this.props.user.UserRoleType.indexOf(UR_COMMERCIAL_GROUP) < 0 ?
            null :
            <TableCell className={classNames(classes.tblBorder, classes.textCenter, classes.iconsWidth)} padding='none'>
              <Tooltip title='Cancelar Reserva' placement='bottom' >
                <IconButton aria-label='Cancel' onClick={() => { this.handleClickCancel(rItem.reservationId) }} className={classNames(classes.buttonSizeTbl)} >
                  <CancelIcon />
                </IconButton>
              </Tooltip>
            </TableCell>}
        </TableRow>
      );
    })
    return cReservationsOnHold;
  }

  renderNoRecordMessages() {
    return NO_TABLE_DATA_MESSAGE;
  }


  render() {
    const { classes } = this.props;
    const { data, order, orderBy, rowsPerPage, page, count, reloading } = this.state;

    return (
      <Paper className={classes.root}>

        <RUReservationsToolbar
          reloadTableBySearch={this.reloadTableBySearch.bind(this)}
          reloadTable={this.reloadTable.bind(this)}
          tableTitle={'RESERVAS EM LISTA DE ESPERA'}
          withSCSearch={false}
        />
        <div className={classes.tableWrapper}>
          <Table>
            <TableHead className={classes.tblHead} >
              <RUReservationsOnHoldTableHeader
                order={order}
                orderBy={orderBy}
                onRequestSort={this.handleRequestSort}
              />
            </TableHead>
            <TableBody>
              {this.renderTableRecords(data)}
            </TableBody>
          </Table>
          {(!data.length) ? this.renderNoRecordMessages() : null}
        </div>
        {reloading && <LinearProgress />}
        <TablePagination
          component='div'
          count={count}
          rowsPerPage={rowsPerPage}
          rowsPerPageOptions={[5, 10, 25, 50]}
          labelRowsPerPage={'Resultados por página:'}
          page={page}
          backIconButtonProps={{ className: classes.pageButton }}
          nextIconButtonProps={{ className: classes.pageButton }}
          onChangePage={this.handleChangePage}
          onChangeRowsPerPage={this.handleChangeRowsPerPage}
          labelDisplayedRows={({ from, to, count }) => `A mostrar resultados ${from}-${to} de ${count}`}
          classes={{ toolbar: classes.tblFooter }}
        />

        <RUReservationsExtendCancelModal
          openModal={this.state.openModal}
          handleClose={this.handleClose.bind(this)}
          openReasons={this.state.openReasons}
          openReasonsTitle={this.state.openReasonsTitle}
          carReservationId={this.state.carReservationId}
          reloadTable={this.reloadTable.bind(this)}
          detectCancellation={this.detectCancellation.bind(this)}
        />

        <SnackbarAlert openError={this.state.openError} alertMessage={this.state.alertMessage} handleCloseSnackbar={this.handleCloseSnackbar} />

      </Paper>
    );
  }
}

RUReservationsOnHoldTable.propTypes = {
  classes: PropTypes.object.isRequired,
  reloadTableBySearch: PropTypes.func,
  reloadTable: PropTypes.func
};

const mapStateToProps = state => ({
  ...state,
});

export default connect(mapStateToProps)(withStyles(styles)(RUReservationsOnHoldTable));


// WEBPACK FOOTER //
// ./src/components/UsedRentals/UsedRentalsReservations/UsedRentalsAllReservations/UsedRentalsOnHoldReservations/RUReservationsOnHoldTable.js